export enum EKeyboardKeycode {
  SPACE = 'Space',
  ENTER = 'Enter',
  NUMPAD_ENTER = 'NumpadEnter'
}
